export function resetRefinementUI() {
  const dropdownEls = document.querySelectorAll('[data-facet-state]');

  dropdownEls.forEach((node) => {
    node.setAttribute('data-facet-state', 'UNPINNED');

    node.querySelectorAll('input[type="checkbox"]').forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = false;
      }
    });

    node.querySelectorAll('input[type="radio"]').forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = Boolean(
          option.value === '' && option.type === 'radio',
        );
      }
    });
  });

  document
    .querySelectorAll('#overflow-dropdown input[type="checkbox"]')
    .forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = false;
      }
    });

  document
    .querySelectorAll('#overflow-dropdown input[type="radio"]')
    .forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = Boolean(
          option.value === '' && option.type === 'radio',
        );
      }
    });
}
